import React, { useEffect } from 'react'
import '../styles/Home.css'
import { useNavigate } from "react-router-dom";
import backgroundImage from '../assets/welcome-background.png';
import ReactGA from "react-ga"

const home = () => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/primal");
  };


  return (
    <div className='home-container'>
      <br/><br/><br/><br/><br/><br/><br/>
      <text className='welcome-title'> Welcome </text>
      <div className='welcome-body'>
      This online interactive demo allows you to create arbitrary multi-agent pathfinding
              (MAPF) instance on square grid worlds, by placing obstacles, agents (robots),
              and corresponding goals, before running a trained PRIMAL model in real-time to
              see agents plan individual collision-free paths to their goal. The full PRIMAL paper
              is available at <a href="https://arxiv.org/abs/1809.03531">this link</a>, while the full
              training and testing code is available on <a href="https://github.com/gsartoretti/PRIMAL">github</a>.
              More information and resources about MAPF can be found at <a href="http://mapf.info/">the main MAPF community website</a>.
              <br /><br />
              </div>
      <div className='button-div'>
        <button onClick={handleClick} className='begin-button'> Get started!</button>
      </div>
      
    </div>
  )
}

export default home
